import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\SettingsForManagementOfDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/SettingsForManagementOfDossierByIdController.php
* @route '/api/dossier/{dossier}/management'
*/
const SettingsForManagementOfDossierByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SettingsForManagementOfDossierByIdController.url(args, options),
    method: 'get',
})

SettingsForManagementOfDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/management',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\SettingsForManagementOfDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/SettingsForManagementOfDossierByIdController.php
* @route '/api/dossier/{dossier}/management'
*/
SettingsForManagementOfDossierByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return SettingsForManagementOfDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\SettingsForManagementOfDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/SettingsForManagementOfDossierByIdController.php
* @route '/api/dossier/{dossier}/management'
*/
SettingsForManagementOfDossierByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SettingsForManagementOfDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\SettingsForManagementOfDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/SettingsForManagementOfDossierByIdController.php
* @route '/api/dossier/{dossier}/management'
*/
SettingsForManagementOfDossierByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SettingsForManagementOfDossierByIdController.url(args, options),
    method: 'head',
})

export default SettingsForManagementOfDossierByIdController